<script>
  export let anchor;
  export let text;
</script>

<style>
  .action {
    padding-top: 2rem;
  }

  .link {
    width: 1rem;
    height: 1rem;
    margin-bottom: -0.15rem;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEyIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEgMUw2IDZMMTEgMSIgc3Ryb2tlPSIjMDA4MUM0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=);
    background-repeat: no-repeat, repeat;
    background-position: center top 50%, 0 0;
    background-size: 0.65em auto, 100%;
    display: inline-block;
  }

  @media only screen and (min-width: 600px) {
    .link {
      font-size: 18px;
    }
  }
</style>

<div class="action">
  <a href={anchor}>
    <span class="link" />
    <span>{text}</span>
  </a>
</div>
